import { DynamicQuestionnaireFields } from '@core/data-access/models/api/dynamic-questionnaire-fields.model';
import {
  BaseQuestionnaireDynamicFormField,
  DynamicFormFields,
  FieldType,
  TextInputField
} from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import {
  isCheckboxField,
  isDropdownField,
  isRadioField,
  isTextInputField
} from '@core/utils/dynamic-form-field/dynamic-form-field-type-guards';
import { forEach, isEmpty, map, sortBy } from 'lodash';

export const questionnaireDynamicFormFieldMapper = (questionnaireDynamicFields: DynamicQuestionnaireFields) => {
  const dynamicFormFields: DynamicFormFields = [];

  forEach(questionnaireDynamicFields, (questionnaireDynamicField, index) => {
    const { id, type, label, isMandatory, values, previousValueId, textLength, selectionLimit } =
      questionnaireDynamicField;

    const questionnaireDynamicFormField: BaseQuestionnaireDynamicFormField = {
      key: id.toString(),
      type: type as FieldType,
      label,
      placeholder: '',
      order: index + 1,
      isRequired: isMandatory,
      isHidden: !!previousValueId,
      isDisabled: false,
      isQuestionnaireField: true,
      previousValueId,
      textLength,
      selectionLimit,
      columns: {
        xs: 12,
        sm: 12,
        md: previousValueId ? 6 : 12,
        lg: previousValueId ? 6 : 12,
        xl: previousValueId ? 6 : 12
      }
    };

    if (isDropdownField(questionnaireDynamicFormField)) {
      const sortedOptions = sortBy(values, 'order');

      questionnaireDynamicFormField.options = map(sortedOptions, ({ id, text }) => ({
        key: id.toString(),
        value: text,
        isDisabled: false
      }));
    } else if (isCheckboxField(questionnaireDynamicFormField)) {
      questionnaireDynamicFormField.columns = {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      };

      questionnaireDynamicFormField.options = map(values, ({ id, text }) => ({
        key: id.toString(),
        label: text,
        value: false,
        isRequired: false,
        isDisabled: false
      }));
    } else if (isRadioField(questionnaireDynamicFormField)) {
      questionnaireDynamicFormField.columns = {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      };

      questionnaireDynamicFormField.options = map(values, ({ id, text }) => ({
        key: id.toString(),
        value: text,
        isDisabled: false
      }));
    } else if (isTextInputField(questionnaireDynamicFormField)) {
      if (!isEmpty(values)) {
        const { id, text } = values[0];

        questionnaireDynamicFormField.type = FieldType.TextInput;
        questionnaireDynamicFormField.key += '_' + id;
        questionnaireDynamicFormField.placeholder = text;
        (questionnaireDynamicFormField as TextInputField).maxLengthValidation = textLength || 150;
        questionnaireDynamicFormField.columns = {
          xs: 12,
          sm: 12,
          md: previousValueId ? 6 : 12,
          lg: previousValueId ? 6 : 12,
          xl: previousValueId ? 6 : 12
        };
      }
    }

    dynamicFormFields.push(questionnaireDynamicFormField);
  });

  return dynamicFormFields;
};
